import { render } from "./Billing.vue?vue&type=template&id=f3c14806&scoped=true"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"

import "./Billing.vue?vue&type=style&index=0&id=f3c14806&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f3c14806"

export default script